import React, { useState, useEffect } from "react";
import "rc-slider/assets/index.css";

export default function InnerRatePanelBox(props) {
  const [numberOfFBAccount, setNumberOfFBAccount] = useState(0);
  const [numberOfInstaAccount, setNumberOfInstaAccount] = useState(0);
  const [numberOfTTAccount, setNumberOfTTAccount] = useState(0);
  const [numberOfYTAccount, setNumberOfYTAccount] = useState(0);
  useEffect(() => {
    if (
      props.instModul &&
      props.fcbkModul &&
      props.tiktokModul &&
      props.youtubeModul
    ) {
      setNumberOfInstaAccount(
        new Set(props?.instModul?.map((item) => item?.pt_user_id))?.size
      );
      setNumberOfFBAccount(
        new Set(props?.fcbkModul?.map((item) => item?.pt_user_id))?.size
      );
      setNumberOfTTAccount(
        new Set(props?.tiktokModul?.map((item) => item?.pt_user_id))?.size
      );
      setNumberOfYTAccount(
        new Set(props?.youtubeModul?.map((item) => item?.pt_user_id))?.size
      );
    }
  }, []);

  return (
    <>
      {(props?.package === "all" || props?.package === "insta") &&
        props?.instModul?.length > 0 &&
        props?.instModul?.map((item, index) => {
          return (
              <div key={`insta-${item.id || index}`} className="package">
                <div className="packge-head-wrap">
                  <h2>{item.name}</h2>
                  <div className="price divForastrictForPrice">
                    ${item.rate}
                    {props.influencerUserType !== "r" && (
                      <span className="asterisk astrictForPrice">*</span>
                    )}
                  </div>
                </div>
                <p>{item.profileDesc}</p>

                <div className="bottom-row">
                  <div className="socialFollowers">
                    <img src="/images/instagram.png" alt="instagram" />
                    {numberOfInstaAccount > 1 &&
                      item.followers !== "" &&
                      item.followers + " Followers"}
                  </div>
                  <button
                    className="add-to-cart"
                    // onClick={() =>
                    //   props?.addToCart({}, item, numberOfInstaAccount)
                    // }
                    onClick={() => {
                      props.addCustomOffer();
                      props.setIsReadOnlyOffer(true);
                      props.setSelectedOfferData(item);
                    }}
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
          );
        })}
      {(props?.package === "all" || props?.package === "tiktok") &&
        props?.tiktokModul?.length > 0 &&
        props?.tiktokModul?.map((item, index) => {
          return (
              <div key={`tiktok-${item.id || index}`} className="package">
                <div className="packge-head-wrap">
                  <h2>{item.name}</h2>
                  <div className="price divForastrictForPrice">
                    ${item.rate}
                    {props.influencerUserType !== "r" && (
                      <span className="asterisk astrictForPrice">*</span>
                    )}
                  </div>
                </div>
                <p>{item.desc}</p>

                <div className="bottom-row">
                  <div className="socialFollowers">
                    <img src="/images/tiktok.png" alt="tiktok" />
                    {numberOfTTAccount > 1 &&
                      item.followers !== "" &&
                      item.followers + " Followers"}
                  </div>
                  <button
                    className="add-to-cart"
                    // onClick={() => props.addToCart({}, item, numberOfTTAccount)}
                    onClick={() => {
                      props.addCustomOffer();
                      props.setIsReadOnlyOffer(true);
                      props.setSelectedOfferData(item);
                    }}
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
          );
        })}

      {(props?.package === "all" || props?.package === "youtube") &&
        props?.youtubeModul?.length > 0 &&
        props?.youtubeModul?.map((item, index) => {
          return (
              <div key={`youtube-${item.id || index}`} className="package">
                <div className="packge-head-wrap">
                  <h2>{item.name}</h2>
                  <div className="price divForastrictForPrice">
                    ${item.rate}
                    {props.influencerUserType !== "r" && (
                      <span className="asterisk astrictForPrice">*</span>
                    )}
                  </div>
                </div>
                <p>{item.desc}</p>

                <div className="bottom-row">
                  <div className="socialFollowers">
                    <img src="/images/youtube.png" alt="youtube" />{" "}
                    {numberOfYTAccount > 1 &&
                      item.followers !== "" &&
                      item.followers + " Followers"}
                  </div>
                  <button
                    className="add-to-cart"
                    // onClick={() => props.addToCart({}, item, numberOfYTAccount)}
                    onClick={() => {
                      props.addCustomOffer();
                      props.setIsReadOnlyOffer(true);
                      props.setSelectedOfferData(item);
                    }}
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
          );
        })}
      {(props?.package === "all" || props?.package === "facebook") &&
        props?.fcbkModul?.length > 0 &&
        props?.fcbkModul?.map((item, index) => {
          return (
              <div key={`facebook-${item.id || index}`} className="package">
                <div className="packge-head-wrap">
                  <h2>{item.name}</h2>
                  <div className="price divForastrictForPrice">
                    ${item.rate}
                    {props.influencerUserType !== "r" && (
                      <span className="asterisk astrictForPrice">*</span>
                    )}
                  </div>
                </div>
                <p>{item.desc}</p>

                <div className="bottom-row">
                  <div className="socialFollowers">
                    <img src="/images/facebook.png" alt="facebook" />
                    {numberOfFBAccount > 1 &&
                      item.followers !== "" &&
                      item.followers + " Followers"}
                  </div>
                  <button
                    className="add-to-cart"
                    // onClick={() => props.addToCart({}, item, numberOfFBAccount)}
                    onClick={() => {
                      props.addCustomOffer();
                      props.setIsReadOnlyOffer(true);
                      props.setSelectedOfferData(item);
                    }}
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
          );
        })}
    </>
  );
}
